<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-17 15:56:31
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-17 16:43:41
 * @FilePath: \pc\coursearrange\src\ApprovalManagement\Map.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>


      <div id="container" style=""></div>

      <div id="tip"></div>



    </div>
</template>

<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=LNZBZ-AJAKJ-E2PFB-X67PO-UYN2S-S5BM5&libraries=view"></script>
<script>
export default {
    props: {

    },
    data(){
        return{

          center:new TMap.LatLng(39.984104, 116.307503),

          Map:null,

        }
    },

    mounted(){

      this.init()
    },

    methods:{

        init () {
            this.Map = new TMap.Map("container", { rotation: 20,  pitch:30,  zoom:12, center: this.center });
            this.handleTilesloadeds()
            this.handlePosition()
        },

        handleTilesloadeds(){
            this.Map.on("tilesloaded", () => { document.getElementById("tip").innerHTML = "加载完毕~~ 亚比 囧囧囧~"  })
        },


        handlePosition(){
            let lookFromList = [
              {
                position: new TMap.LatLng(40.04374524409231, 116.2865218786128, 50),
                rotation: [80, 0, 0],
                percentage: 0,
              },

              {
                position: new TMap.LatLng(40.049407036771356, 116.28522908966829, 50),
                rotation: [80, 0, 0],
                percentage: 0.25,
              },
              {
                position: new TMap.LatLng(40.04970116881027, 116.28443717763798, 50),
                rotation: [80, 0, 90],
                percentage: 0.3,
              },
              {
                position: new TMap.LatLng(40.04908656312387, 116.28076901740587, 50),
                rotation: [80, 0, 90],
                percentage: 0.45,
              },

              {
                position: new TMap.LatLng(40.04876101655684, 116.28052871173372, 50),
                rotation: [80, 0, 180],
                percentage: 0.5,
              },

              {
                position: new TMap.LatLng(40.04336691175791, 116.28170569825716, 50),
                rotation: [80, 0, 180],
                percentage: 0.75,
              },
              {
                position: new TMap.LatLng(40.04298529869431, 116.28218813579929, 50),
                rotation: [80, 0, -90],
                percentage: 0.8,
              },
              {
                position: new TMap.LatLng(40.04347544510598, 116.28571716461806, 50),
                rotation: [80, 0, -90],
                percentage: 0.95,
              },
              {
                position: new TMap.LatLng(40.04374524409231, 116.2865218786128, 50),
                rotation: [80, 0, 0],
                percentage: 1,
              },
            ]

            let keyFrames = lookFromList.map((lookFrom) =>{
                let position = lookFrom.position
                let rotation = lookFrom.rotation
                let percentage = lookFrom.percentage
                let keyFrame = this.Map.getMapViewWhenLookFrom(position, rotation)
                keyFrame.percentage = percentage
                return keyFrame
            })

            this.Map.startAnimation( keyFrames, {  duration: 30 * 1000,  loop: Infinity })

      }

  }

}
</script>



<style scoped lang="less">

    body {
        height: 100%;
        margin: 0px;
        padding: 0px;
        overflow: hidden;
    }


    #container {
      position: absolute;
      width: 80vw;
      height: 80vh;
    }


    #tip {
        position: absolute;
        margin-top: 10px;
        margin-left: 10px;
        background: #7fdf60;
        color: #19bacf;
        width: 200px;
        height: 30px;
        line-height: 30px;
        border-radius: 3px;
        padding-left: 5px;
    }



</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/Map.vue